module.exports = __webpack_public_path__ + "assets/img/budapark2-320.68927744.webp";